import { handleActions } from "redux-actions";
import * as actions from "./actions";
import { SEGMENT_TYPES } from "./constants";

export const initialState = {
  selectedSegment: SEGMENT_TYPES.private,
};

const changeSegment = (previousState, { payload: { segment } }) => ({
  selectedSegment:
    (segment.deferToPrefilled && previousState.prefilledSegment) || segment.id,
  prefilledSegment: segment.persistentPrefill
    ? segment.id
    : previousState.prefilledSegment,
});

export default handleActions(
  {
    [actions.changeSegment]: changeSegment,
    [actions.prefillSegment]: changeSegment,
  },
  initialState
);
